// 语言工具：URL 是语言的唯一权威来源（/en 前缀即英文），
// localStorage 只作"记住偏好 + 首次建议"，绝不与 URL 争夺控制权
import { LOCALE_ZH, LOCALE_EN } from '../locales'

const STORAGE_KEY = 'portal-locale'

// 根据路径判断语言：/en 或 /en/... 为英文，其余为中文
export function localeOfPath(path) {
  return (path === '/en' || path.startsWith('/en/')) ? LOCALE_EN : LOCALE_ZH
}

// 去掉语言前缀：'/en/news' → '/news'；'/en' → '/'
export function stripLocale(path) {
  if (path === '/en') return '/'
  return path.replace(/^\/en(?=\/)/, '')
}

// 按目标语言生成路径：
// localePath('/news/abc', 'en-US') → '/en/news/abc'
// localePath('/en/news', 'zh-CN')  → '/news'
export function localePath(path, locale) {
  const bare = stripLocale(path)
  return locale === LOCALE_EN ? (bare === '/' ? '/en' : '/en' + bare) : bare
}

// 读取/保存用户语言偏好（隐私模式下静默降级）
export function getStoredLocale() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch (e) {
    return null
  }
}

export function setStoredLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch (e) {
    /* 忽略：无法写入时仅本次会话生效 */
  }
}

// 浏览器语言检测：含任意英文变体则返回英文
export function detectBrowserLocale() {
  const langs = (typeof navigator !== 'undefined' && (navigator.languages || [navigator.language || ''])) || []
  return langs.some(l => l && l.toLowerCase().startsWith('en')) ? LOCALE_EN : LOCALE_ZH
}
